import { render } from "./Todos.vue?vue&type=template&id=fe57d1da"
import script from "./Todos.vue?vue&type=script&lang=js"
export * from "./Todos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__